<template>
  <div>
    <div style="margin-bottom: 20px;margin-top: 30px">
      <router-view></router-view>
      <el-button size="small" type="success" icon="el-icon-plus"
        v-if="['ADMIN','MANAGER','SALES_ASSI_MANAGER','SALES_ASSI'].includes(role)" @click="handleEdit()">添加</el-button>
    </div>
    <w-table :columns="column" :table-data="tableData" @rowSelection="rowSelection"
      @getTableSearchSortCon="getTableSearchSortCon" :isPagination="true"
      :table-col-check="{isShow:true,name:'Stock-in2'}" ref="wMyTable" :page="page"
      @pageChange="handlePagePagination" :isShowRowSelection="true">
      <div slot="materialType" slot-scope="{record,text}">
        <el-tag :type="getMaterialColor(text,'tagType')"
          :style="{color: getMaterialColor(text,'color'),'background-color':getMaterialColor(text,'backgroundColor')}">
          {{getMaterialColor(text,'name')}}</el-tag>
      </div>
      <div slot="materialName" slot-scope="{record,text}">
        <el-tooltip placement="bottom">
          <div slot="content">点击查看详细物料信息</div>
          <el-link type="primary" @click="showLexicon(text)" :underline="false">
            <i v-html="viewDetailIcon"></i>{{text}}
          </el-link>
        </el-tooltip>
      </div>
    </w-table>
    <add-edit-stock-in v-if="showAddEditDialog" :show-dialog="showAddEditDialog" :select-type="selectType"
      :select-detail="selectDetail" @submit="closeAddEditDialog"></add-edit-stock-in>
    <lexicon-details v-if="showLexiconDetail" :show-dialog="showLexiconDetail" :select-detail="LexiconDetail"
      @submit="closeShowLexicon"></lexicon-details>
    <picture-loading v-if="loading"></picture-loading>
  </div>
</template>

<script>

import TableHeadNote from "@/components/customerTable/TableHeadNote.vue";
import {tableOperationMixin} from "@/mixins/tableOperation";
import {getDataInLocalStorage} from "@/utils/localStorage";
import LexiconDetails from "@/components/material/lexicon/LexiconDetails.vue";
import {getStockPage} from "@/api/dilivery/material/stockIn";
import {stockIn} from "@/utils/data/tableCol/material/stockIn/stockIn";
import {getLexiconPage} from "@/api/dilivery/material/lexicon";
import AddEditStockIn from "@/components/material/stockIn/AddEditStockIn.vue";
import {viewDetailIcon} from "@/utils/icon";
import PictureLoading from "@/components/customerTable/PictureLoading.vue";
import {getMaterialColor} from "@/color";

export default {
  name: "StockIn",
  components: {PictureLoading, AddEditStockIn, LexiconDetails, TableHeadNote},
  mixins: [tableOperationMixin],
  data() {
    return {
      role: '',
      loading:true,
      searchConditionTag: [],//搜索tag
      sortConditionTag: [],
      tableData: [],
      selectable: [],
      showAddEditDialog: false, //控制编辑页面显示与隐藏
      selectDetail: '',
      showLexiconDetail:false,
      LexiconDetail: '',
      selectType: '',
      page: {
        pageSize: 10,
        currentNum: 1,
        total: null
      },
      viewDetailIcon: viewDetailIcon,
    }
  },
  computed: {
    column() {
      return JSON.parse(JSON.stringify(stockIn(this.searchConditionTag || {})))
    }
  },
  created() {
    this.role = getDataInLocalStorage('role')
  },
  mounted() {
    this.getData()
  },
  methods: {
    getMaterialColor,
    //已提交表格选择框
    rowSelection(selectedRows) {
      this.selectable = selectedRows
    },
    async showLexicon(materialName){
      try{
        const data = {"query#materialName.EQ":materialName}
        const res = await getLexiconPage({}, data)
        if (res.code === 200 && res.data.records.length>0) {
          this.LexiconDetail = res.data.records[0]
          this.showLexiconDetail = true
        }
      } catch (error) {
        console.log(error);
      }
    },
    getTableSearchSortCon(searchConditionTag, sortConditionTag) {
      this.searchConditionTag = searchConditionTag
      this.sortConditionTag = sortConditionTag
      this.getData('search')
    },
    // 获取邮寄表数据
    getData(type) {
      this.loading = true
      let params = {
        'page.current': this.page.currentNum,
        'page.size': this.page.pageSize,
      }
      if (type) {
        params['page.current'] = 1
        params['page.size'] = 10
      }
      this.sortConditionTag.forEach(item => {
        params["order"] = item.colName + "." + item.order
      })
      let sendData = {}
      sendData = this.getSearch(sendData)
      getStockPage(params, sendData).then(res => {
        this.loading = false
        if (res.code === 200) {
          this.tableData = res.data.records
          this.page.currentNum = parseInt(res.data.current)
          this.page.pageSize = parseInt(res.data.size)
          this.page.total = parseInt(res.data.total)
        }
      }).catch(() => {
        this.loading = false
      })
    },
    getSearch(sendData) {
      let keys = ['materialName']
      this.searchConditionTag.forEach(item => {
        if(keys.includes(item.key)){
          sendData[item.key] = item.value
        }else{
          sendData["query#" + item.key + ".LIKE"] = item.value
        }
      })
      return sendData
    },
    //页码的变动
    handlePagePagination(page) {
      this.page.currentNum = page.currentNum
      this.page.pageSize = page.pageSize
      this.getData()
    },
    //编辑表格显示列
    handleEdit(row) {
      if (row !== undefined && row !== 'undefined') {
        this.selectDetail = row
        this.selectType = 'edit'
      } else {
        this.selectType = 'add'
        this.selectDetail = ''
      }
      this.showAddEditDialog = true
    },
    closeShowLexicon(){
      this.$nextTick(() => {
        this.showLexiconDetail = false
      })
    },
    // 关闭编辑、增加弹出框
    closeAddEditDialog(type) {
      if (type === 'confirm') {
        this.getData()
      }
      this.$nextTick(() => {
        this.showAddEditDialog = false
      })
    }
  }
}
</script>

<style scoped>
.status-tag-container {
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中，如果需要 */
  height: 100%; /* 确保标签在单元格中垂直居中 */
}
</style>
